import React, { ReactNode } from 'react'
import LoadingBackdrop from './LoadingBackdrop'

export const LazyLoadPage: React.FC<{ children: ReactNode }> = ({ children }: { children: ReactNode }) => {
  return (
    <React.Suspense fallback={<LoadingBackdrop loading={true} />}>
      {children}
    </React.Suspense>
  )
}
export default LazyLoadPage
